module.exports = __webpack_public_path__ + "08f04b4c706c7d5bfbd534784362141e.png";